/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';
import PropTypes from 'prop-types';
import Body from '@redturtle/iovisit-theme/components/Blocks/Multimedia/Body';

const View = ({ data }) => {
  //const [isClient, setIsClient] = React.useState(null);
  // const [leadimagePortal, setLeadimagePortal] = React.useState(null);
  // React.useEffect(() => {
  //   let portal = document.getElementById('leadimage-portal');
  //   setLeadimagePortal(portal);
  //   setIsClient(true);
  //   if (data.leadimage && portal) {
  //     document.getElementById('leadimage-portal').classList.add('with-content');
  //   }
  // }, []);

  // return
  // data.leadimage && leadimagePortal ? (
  //   <Portal
  //     node={isClient && document.getElementById('leadimage-portal')}
  //     className="with-content"
  //   >
  //     <div className="block slider">
  //       <Body {...data} />
  //     </div>
  //   </Portal>
  // ) :
  return (
    <div className="block multimedia">
      <Body {...data} />
    </div>
  );
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
